export default __webpack_public_path__ + "static/media/cross.7a02ca06.svg";